document.addEventListener('DOMContentLoaded', function() {
  // Update the URL for the 5 pieces product card
  const fivePiecesLink = document.querySelector('product-card[handle="choose-5-pieces-for-60"] .product-card__media');
  if (fivePiecesLink) {
    fivePiecesLink.href = "https://casainte.com/pages/5-piece-silver-bundle";
  }

  // Update the URL for the 10 pieces product card
  const tenPiecesLink = document.querySelector('product-card[handle="choose-10-pieces-for-100"] .product-card__media');
  if (tenPiecesLink) {
    tenPiecesLink.href = "https://casainte.com/pages/5-piece-gold-bundle";
  }
});

document.addEventListener('DOMContentLoaded', function() {
  // Update the URL for the 5 pieces product card
  const fivePiecesLink = document.querySelector('a[href="/products/choose-5-pieces-for-60"]');
  if (fivePiecesLink) {
    fivePiecesLink.href = "https://casainte.com/pages/5-piece-silver-bundle";
  }

  // Update the URL for the 10 pieces product card
  const tenPiecesLink = document.querySelector('a[href="/products/choose-10-pieces-for-100"]');
  if (tenPiecesLink) {
    tenPiecesLink.href = "https://casainte.com/pages/5-piece-gold-bundle";
  }
});